import paths from "routes/paths";
import XHTTP from "services/api/xhttp";
import CommonUtils from "services/common/utils";
import AbstractApi from "services/cores/abstractApi";

class DisplaysApi extends AbstractApi {
  retrieveList = (filters = {}) => {
    const queryString = CommonUtils.buildQueryStringFromObject({
      ...filters,
    });

    return XHTTP(`${this.config?.paths?.default || ""}?${queryString}`, {
      method: "get",
    });
  };

  updateStandBy = (id, standBy) => {
    return XHTTP(
      `${this.config?.paths?.updateStandBy.replace(
        ":id",
        id
      )}?stand_by=${standBy}`,
      { method: "put" }
    );
  };
  updateRule = (id, rule) => {
    return XHTTP(`${this.config?.paths?.udpdateRule.replace(":id", id)}`, {
      method: "put",
      body: JSON.stringify(rule),
    });
  };

  updateEmergencyRule = (id, isActive) => {
    return XHTTP(
      `${this.config?.paths?.updateEmergencyRule.replace(
        ":id",
        id
      )}?is_active=${isActive}`,
      { method: "put" }
    );
  };
}

export default new DisplaysApi({
  paths: {
    default: paths.api.iot.displays.general,
    updateStandBy: paths.api.iot.displays.udpdateStandBy,
    udpdateRule: paths.api.iot.displays.udpdateRule,
    updateEmergencyRule: paths.api.iot.displays.updateEmergencyRule,
  },
});
